/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */
/**
 * Ext Libs
 */
import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {LocalStorageService} from 'ngx-store';

/**
 * Services
 */
import {ConsignmentService} from '../../providers/consignment.service';

@Component({
  selector: 'app-consignment-detail',
  templateUrl: './consignment-detail.component.html',
  styleUrls: ['./consignment-detail.component.css']
})
export class ConsignmentDetailComponent implements OnInit {
  private sessionUser: any;
  public loading: boolean;
  public fetchError: boolean;
  public errorMessage: string;
  public consignmentDetails: any;

  private referrer: string;
  private file_name: string;

  /**
   * Initialize the class
   */
  constructor(private router: Router, private route: ActivatedRoute, private consignmentService: ConsignmentService,
              private localStorage: LocalStorageService, private activatedRoute: ActivatedRoute) {
  }

  /**
   * On Init Lifecycle Hook
   */
  ngOnInit() {
    // Check current ongoing session
    this.checkSession();
    // Get the Id of the Customer from the URL
    // this.activatedRoute.params.subscribe((params: Params) => {
      // this.referrer = params['referrer'];
      // this.file_name = params['file_name'];
      // console.log(this.referrer);
      // console.log(this.file_name);
      // if (this.referrer !== undefined && this.file_name !== undefined) {
      //   console.log("asfasdfasfdsfsad",this.referrer, this.file_name)
      //   const pdf_url = `https://cdn.chemfields.com/downloads/${this.file_name}.pdf`;
      //   console.log("pdf_url", pdf_url )
      //   window.open(pdf_url, '_blank');
        // this.downloadAttachment(pdf_url)
      // }
    // });
  }

  /**
   * Get Current Session
   */
  checkSession() {
    let customer = this.localStorage.get('customer-session');
    // Check If Customer ID exists
    if (customer && customer.id) {
      this.sessionUser = customer;
      // Get Consginments Listing
      let id = this.route.snapshot.paramMap.get('id');
      this.getConsignmentDetails(id);
    }

    // Check If Customer ID does not exist
    if (!customer) {
      // If so, redirect to login
      this.router.navigate(['/login']);
    }
  }

  /**
   * Get Consignments Detail Data using Consignment ID
   */
  getConsignmentDetails(id: string) {
    this.loading = true;

    let params = {
      'consignment_id': id
    };

    this.consignmentService.details(params).subscribe(
      (data) => {
        this.handleConsignmentResponseSucceess(data);
      },
      (err) => {
        this.handleConsignmentResponseError(err);
      },
    );
  }

  /**
   * Handle Consignments Succeess Response
   */
  handleConsignmentResponseSucceess(response) {
    this.loading = false;

    if (response.status == 'SUCCESS') {
      this.consignmentDetails = response.consignment;
      this.fetchError = false;
    }
  }

  /**
   * Handle Consignments Error Response
   */
  handleConsignmentResponseError(err) {
    this.loading = false;
    let message = '';
    this.fetchError = true;

    // Bad Data or No data to the server
    if (err.status == 400) {
      message = 'Bad data passed!';
    }

    // Access Denies
    if (err.status == 403) {
      message = 'Access Denied!';
    }

    // Username or Password does not match
    if (err.status == 409) {
      message = 'Username or Password does not match';
    }

    // Error from Server
    if (err.status == 500) {
      message = 'Oops, something went wrong. Please try again.';
    }

    // No Network Error
    if (err.status == -1) {
      message = 'No Internet Connection. Please try to connect to a network and try again.';
    }

    this.errorMessage = message;
  }

  /**
   * Download COA
   */
  downloadAttachment(downloadURL) {
    window.open(downloadURL, '_blank');
  }

  /**
   * Go Back
   */
  goBack() {
    this.router.navigate(['/consignments-list']);
  }
}
